import React from 'react';
import {Row, Textarea, Button, Col} from "react-materialize";
import CryptoFunction from "../functions/CryptoFunctions";

class ButtonMy extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {


        return (

            <Button waves="light" style={{marginRight: '5px'}}
                    className={'purple darken-1'}
                    onClick={()=>{
                        this.props.whyAreYouRunning()
                    }}
            >
                {this.props.text}
            </Button>


        )
    }
}

export default ButtonMy;